import { NotAuthorized } from "@/components/NotAuthorized";
import { LoadingState } from "@/components/podkit/loading/LoadingState";
import { Text } from "@/components/podkit/typography/Text";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { useFlagOnaAIEnabled } from "@/hooks/use-flag";
import { useMembership } from "@/hooks/use-membership";
import { AgentCommands } from "@/routes/settings/organization/agents/AgentCommands";
import { AgentIntegrations } from "@/routes/settings/organization/agents/AgentIntegrations";
import { AgentPolicies } from "@/routes/settings/organization/agents/AgentPolicies";
import { OrganizationRole } from "gitpod-next-api/gitpod/v1/organization_pb";
import type { FC } from "react";

export const AgentsPage: FC = () => {
    useDocumentTitle("Agents");

    const { membership, isPending: isLoadingMembership } = useMembership();
    const { value: isOnaAIEnabled, loading: isLoadingOnaAI } = useFlagOnaAIEnabled();

    if (!membership && isLoadingMembership) {
        return <LoadingState />;
    }

    if (membership?.userRole !== OrganizationRole.ADMIN) {
        return <NotAuthorized />;
    }

    if (isLoadingOnaAI) {
        return <LoadingState />;
    }

    if (!isOnaAIEnabled) {
        return <NotAuthorized />;
    }

    return (
        <div className="flex flex-col gap-6" data-testid="agents-page">
            <Text className="text-base text-content-secondary">
                Configure agent commands, policies, and integrations for your organization.
            </Text>

            <AgentPolicies />
            <AgentIntegrations />
            <AgentCommands />
        </div>
    );
};
